/**
 * Cache wrapper for the TeamMembers list. TtlCache (15-min, single "all" entry, in-flight
 * coalescing) around `API.Data.TeamMembers.get.all()`. Team members / operators are global
 * reference data that change rarely, so a shared cache spares every consumer a fresh fetch.
 */

import { TeamMember } from "@domain/CRM/teamMember";
import { TtlCache } from "../../../cache/ttlCache";
import { API } from "../../../api";

const LIST_TTL_MS = 15 * 60 * 1000;
const LIST_KEY = "all" as const;

class CachedTeamMembersList {
	private cache = new TtlCache<typeof LIST_KEY, TeamMember[]>(LIST_TTL_MS, () => API.Data.TeamMembers.get.all());

	/** Synchronous TTL cache hit, or null if missing/expired. */
	public peek(): TeamMember[] | null {
		return this.cache.peek(LIST_KEY);
	}

	public get(): Promise<TeamMember[]> {
		return this.cache.get(LIST_KEY);
	}

	public clear(): void {
		this.cache.clear();
	}
}

export class CachedTeamMembersAPI {
	public list = new CachedTeamMembersList();
}
